module.exports = __webpack_public_path__ + "static/media/31JFA9.4bc298b0.jpg";